import Splide from "@splidejs/splide";

// ===================================================
// $SLIDERS
// ===================================================

const sliders = {};

// --- hero ---

const heroEl = document.querySelector("#home-hero-slider");
if (heroEl) {
  sliders.hero = new Splide(heroEl, {
    type: "loop",
    perPage: 1,
    autoplay: true,
    pagination: true,
    arrows: false,
  }).mount();
}

// --- reassurance ---

const reassuranceEl = document.querySelector("#reassurance .splide");
if (reassuranceEl) {
  sliders.reassurance = new Splide(reassuranceEl, {
    autoplay: true,
    arrows: false,
    focus: 0,
    omitEnd: true,
  });

  sliders.reassurance.on("overflow", function (isOverflow) {
    sliders.reassurance.options = {
      pagination: isOverflow,
      drag: isOverflow,
    };
  });

  sliders.reassurance.mount();
}

// --- selected products ---

window.addEventListener("load", () => {
  document.querySelectorAll(".selected-products .splide").forEach((el) => {
    let maxHeight = 0;
    el.querySelectorAll(".splide__slide .card-content").forEach((slide) => {
      maxHeight = Math.max(maxHeight, slide.offsetHeight + 313);
    });
    //alert(maxHeight);

    new Splide(el, {
      type: "loop",
      autoWidth: true,
      height: maxHeight,
      pagination: false,
      arrows: true,
      gap: "1.25rem",
      focus: 0,
      omitEnd: true,
    }).mount();
  });
});
